module.exports = __webpack_public_path__ + "img/industry-7.149bcb14.jpg";